<template>
  <StarsBackground />
  <SiteNav />
  <router-view />
  <SiteFooter />
</template>

<script setup>
import StarsBackground from '@/components/StarsBackground.vue'
import SiteNav from '@/components/SiteNav.vue'
import SiteFooter from '@/components/SiteFooter.vue'
</script>

<style>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
#app > footer {
  margin-top: auto;
}
</style>
